import { createContext } from "react";
import type { MetadataActions } from "../MetadataProvider.types";

const MetadataActionsContext = createContext<MetadataActions | undefined>(undefined);
MetadataActionsContext.displayName = "MetadataActionsContext";

export default MetadataActionsContext;
